export default {
  name: 'MonitoringCockpit',
  render () { return <router-view/> }
}
